import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import AddNewPortfolio from '../../components/admincomponents/AddNewPortfolio';

function Addblog({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <AddNewPortfolio />            
    </>
  );
}

export default Addblog;
